import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AbstractControl } from '@angular/forms';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { FormOfLease, RentalObjectCategory } from '../../model/const/enums';
import { VacantRentalObjectService } from '../../service/data/vacant-period.service';

@Component({
    selector: 'app-vacant-period-autocomplete',
    templateUrl: './vacant-period-autocomplete.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VacantPeriodAutocompleteComponent implements OnInit, OnDestroy {
  constructor(private service: VacantRentalObjectService) {}
  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
    this.items = null;
  }

  // Templates bind the string category name (e.g. 'Other'); the backend endpoint accepts the name.
  @Input() category: RentalObjectCategory | string;
  @Input() formOfLease: FormOfLease | string;
  private _control: FormControlEx;
  @Input() set control(value: AbstractControl) {
    this._control = value as FormControlEx;
  }
  get control(): FormControlEx {
    return this._control;
  }

  items: any[];

  private _subscription = new Subscription();

  ngOnInit() {
    this._subscription.add(
      this.service.getByCategory({ category: this.category, formOfLease: this.formOfLease }).subscribe(data => (this.items = data))
    );
  }
}
